import { useState, Fragment } from 'react';
import { GridFilterInputValueProps } from '@mui/x-data-grid';
import { ComboBox } from '@airbus/components-react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  headerFilterBox: {
    padding: '10px 5px 5px 5px !important',
  },
});

export default function RenderHeaderMultiSelectFilterField(
  props: GridFilterInputValueProps & {
    headerFilterMenu: React.ReactNode;
    clearButton: React.ReactNode;
    valueOptions: [];
    label: string;
  },
) {
  const classes = useStyles();
  const { item, valueOptions, applyValue, headerFilterMenu, clearButton } = props;
  const [selected, setSelected] = useState(item?.value ?? null);

  const handleFilterChange = (newValue) => {
    setSelected(newValue);
    applyValue({ ...item, value: newValue });
  };

  return (
    <Fragment>
      {headerFilterMenu}
      <div className={classes.headerFilterBox}>
        <ComboBox
          multiple
          className='w-100'
          hideClear={true}
          autoFocus={true}
          options={valueOptions}
          value={selected}
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          onChange={handleFilterChange}
        />
      </div>
      {clearButton}
    </Fragment>
  );
}
